<template>
  <div class="mysection">
    <div class="pjwxlist">
      <div class="db_desc_more">
        <el-tabs type="border-card" value="borrow" @tab-click="handleTabClick" stretch>
          <el-tab-pane label="借入项目" name="borrow">

              <dl>
                <dt>产品类型:</dt>
                <dd>
                  <el-radio-group v-model="filters.projectCategory" v-on:change="getBorrowProjects" size="small">
                    <el-radio-button label="all">全部</el-radio-button>
                    <el-radio-button
                      v-for="item in projectCategoryArray"
                      :key="item.id"
                      :label="item.id"
                      :value="item.id">{{item.name}}</el-radio-button>
                  </el-radio-group>
                </dd>
              </dl>

              <dl>
                <dt>还款方式:</dt>
                <dd>
                  <el-radio-group v-model="filters.repaymentMethod" v-on:change="getBorrowProjects" size="small">
                    <el-radio-button label="all">全部</el-radio-button>
                    <el-radio-button
                      v-for="item in repaymentMethodArray"
                      :key="item.id"
                      :label="item.id"
                      :value="item.id">{{item.name}}</el-radio-button>
                  </el-radio-group>
                </dd>
              </dl>

              <div class="tab_con">
                <h3>
                  <el-button type="default" size="small" @click="reOrderProject('borrow','publish_time')" id="borrow_publish_time">时间
                    <!--<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                  </el-button>
                  <el-button type="default" size="small" @click="reOrderProject('borrow','amount')" id="borrow_amount">金额
                    <!--<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                  </el-button>

                  <el-button type="default" size="small" @click="reOrderProject('borrow','real_time_status')" id="borrow_real_time_status">最新项目信息
                  </el-button>

                  <div class="list_title_right">共<span class="color_red">{{bTotal}}</span>条</div>
                </h3>
                <ul>
                  <li v-for="bProj in borrowProjects">
                    <h4>{{bProj.projectName}}：{{bProj.projectCode}}</h4>
                    <el-row class="idata">
                      <el-col :span="8"><span class="color_red">{{bProj.amount}}<sub>元</sub></span>借款金额</el-col>
                      <el-col :span="8"><span>{{bProj.yieldRate}}<sub>%</sub></span>预期收益率</el-col>
                      <el-col :span="8"><span>{{bProj.deadline}}<sub>天</sub></span>借款期限</el-col>
                    </el-row>
                    <el-row class="ml_desc">
                      <el-col :span="24">
                        借款主体：{{borrowMainFormatter(bProj.borrowMain)}}<br />
                        还款方式：{{repaymentMethodFormatter(bProj.repaymentMethod)}}
                      </el-col>
                    </el-row>
                    <el-row class="statics">
                      <el-col :span="16"><span>保证方式：{{bProj.guaranteeMethodNames}}</span></el-col>
                      <el-col :span="8">
                        <el-button type="default" v-if="bProj.realTimeStatus == 2" @click="goProjectDetail('borrow',bProj.id)" plain>已过期</el-button>
                        <el-button type="default" v-else-if="bProj.realTimeStatus == 1" @click="goProjectDetail('borrow',bProj.id)" plain>已完成</el-button>
                        <el-button size="small" type="primary" v-else @click="goProjectDetail('borrow',bProj.id)" plain>
                          项目详情
                        </el-button>
                      </el-col>
                    </el-row>
                  </li>
                </ul>
                <!--<el-pagination-->
                  <!--background-->
                  <!--@current-change="handleCurrentChangeBorrow"-->
                  <!--:page-size="bPageSize"-->
                  <!--layout="prev, pager, next"-->
                  <!--:total="bTotal">-->
                <!--</el-pagination>-->
              </div>
              <div class="load_more">
                  <el-button size="small" type="primary" v-if="this.showBorrowDataMore" @click="getBorrowProjects('borrowMore')">加载更多</el-button>
                  <el-button size="small" type="default" v-if="!this.showBorrowDataMore" :disabled="!this.showBorrowDataMore">已全部加载</el-button>
              </div>

              </el-tab-pane>

            <el-tab-pane label="出借项目" name="loan">
              <div class="tab_con">
                <h3>
                  <el-button type="default" size="small" @click="reOrderProject('loan','publish_time')" id="loan_publish_time">时间
                    <!--<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                  </el-button>
                  <el-button type="default" size="small" @click="reOrderProject('loan','amount')" id="loan_amount">金额
                    <!--<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                  </el-button>
                  <el-button type="default" size="small" @click="reOrderProject('loan','real_time_status')" id="loan_real_time_status">最新项目信息
                  </el-button>
                  <div class="list_title_right">共<span class="color_red">{{lTotal}}</span>条</div>
                </h3>
                <ul>
                  <li v-for="lProj in loanProjects">
                    <h4>{{lProj.projectName}}：{{lProj.projectCode}}</h4>
                    <el-row class="idata">
                      <el-col :span="8"><span class="color_red">{{lProj.amount}}<sub>元</sub></span>出借金额</el-col>
                      <el-col :span="8"><span>{{lProj.yieldRate}}<sub>%</sub></span>期望收益率</el-col>
                      <el-col :span="8"><span>{{lProj.deadline}}<sub>天</sub></span>出借期限</el-col>
                    </el-row>
                    <el-row class="ml_desc">
                      <el-col :span="24">
                        出借方：{{lProj.lenders}}<br/>
                        还款方式：{{repaymentMethodFormatter(lProj.repaymentMethod)}}
                      </el-col>
                    </el-row>
                    <el-row class="statics">
                      <el-col :span="16"><span>要求保证方式：{{lProj.guaranteeMethodNames}}</span></el-col>
                      <el-col :span="8">
                        <el-button type="default" v-if="lProj.realTimeStatus == 2" @click="goProjectDetail('loan',lProj.id)" plain>已过期</el-button>
                        <el-button type="default" v-else-if="lProj.realTimeStatus == 1" @click="goProjectDetail('loan',lProj.id)" plain>已完成</el-button>
                        <el-button size="small" type="primary" v-else @click="goProjectDetail('loan',lProj.id)" plain>
                          项目详情
                        </el-button>
                      </el-col>
                    </el-row>
                  </li>
                </ul>
                <!--<el-pagination-->
                  <!--background-->
                  <!--@current-change="handleCurrentChangeLoan"-->
                  <!--:page-size="lPageSize"-->
                  <!--layout="prev, pager, next"-->
                  <!--:total="lTotal">-->
                <!--</el-pagination>-->
              </div>
              <div class="load_more">
                <el-button size="small" type="primary" v-if="this.showLoanDataMore"  @click="getLoanProjects('loanMore')">加载更多</el-button>
                <el-button size="small" type="default" v-if="!this.showLoanDataMore" :disabled="!this.showLoanDataMore">已全部加载</el-button>
              </div>
            </el-tab-pane>
            <el-tab-pane label="债权转让" name="assignment">
              <div class="tab_con">
                <h3>
                  <el-button type="default" size="small" @click="reOrderProject('assignment','publish_time')" id="assignment_publish_time">时间
                    <!--<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                  </el-button>
                  <el-button type="default" size="small" @click="reOrderProject('assignment','amount')" id="assignment_amount">金额
                    <!--<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                  </el-button>
                  <el-button type="default" size="small" @click="reOrderProject('assignment','real_time_status')" id="assignment_real_time_status">最新项目信息
                  </el-button>
                  <div class="list_title_right">共<span class="color_red">{{aTotal}}</span>条</div>
                </h3>
                <ul>
                  <li v-for="aProj in assignmentDebt">
                    <h4>{{aProj.creditorName}}：{{aProj.projectCode}}</h4>
                    <el-row class="idata">
                      <el-col :span="6"><span class="color_red">{{aProj.amount}}<sub>元</sub></span>转让金额</el-col>
                      <el-col :span="6"><span>{{aProj.yieldRate}}<sub>%</sub></span>预期收益率</el-col>
                      <el-col :span="6"><span>{{aProj.deadline}}<sub>天</sub></span>剩余期限</el-col>
                      <el-col :span="6"><span>{{aProj.transferor}}</span>转让方</el-col>
                    </el-row>
                    <el-row class="ml_desc">
                      <el-col :span="24">
                        还款方式：{{repaymentMethodFormatter(aProj.repaymentMethod)}}
                      </el-col>
                    </el-row>
                    <el-row class="statics">
                      <el-col :span="16"><span>保证方式：{{aProj.guaranteeMethodNames}}</span></el-col>
                      <el-col :span="8">
                        <el-button size="small" v-if="aProj.realTimeStatus ==1" type="primary"  @click="goProjectDetail('assignment',aProj.id)" plain>
                          已完成
                        </el-button>
                        <el-button size="small" v-else-if="aProj.deadline > 0" type="primary"  @click="goProjectDetail('assignment',aProj.id)" plain>
                          项目详情
                        </el-button>
                        <el-button type="default" v-else @click="goProjectDetail('assignment',aProj.id)" plain>已过期</el-button>
                      </el-col>
                    </el-row>
                  </li>
                </ul>
                <!--<el-pagination-->
                  <!--background-->
                  <!--@current-change="handleCurrentChangeAssignment"-->
                  <!--:page-size="aPageSize"-->
                  <!--layout="prev, pager, next"-->
                  <!--:total="aTotal">-->
                <!--</el-pagination>-->
              </div>
              <div class="load_more">
                <el-button size="small" type="primary" v-if="this.showAssignmentDebtDataMore" @click="getAssignmentDebts('assignmentMore')">加载更多</el-button>
                <el-button size="small" type="default" v-if="!this.showAssignmentDebtDataMore" :disabled="!this.showAssignmentDebtDataMore">已全部加载</el-button>
              </div>
            </el-tab-pane>
          </el-tabs>
      </div>

    </div>
    <!-- 弹出层 -->
    <el-dialog width="90%" title="提示消息" :visible.sync="dialogMsgVisible" top="20vh" center>
      <el-row>
        <el-col>
          温馨提示：您需要注册账户并登录成功后才能查看项目详情，会员可直接点击项目详情发送信息，平台将会在24小时内安排专人主动和您取得联系。或者您可以拨打服务热线 <a href="tel:4000297800">400 029 7800</a> 获取项目详细信息。
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goRegister(state,goType)">立即注册</el-button>
        <el-button @click="goLogin(state,goType)">直接登录</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import {reqBorrowProjectListPage,reqLoanProjectListPage,reqAssignmentDebtListPage,reqValidateWebUser} from '../../api/weixin-api'
  import {reqGetDictionaryListByCode,reqGetOneByCode} from '../../api/weixin-api';

  export default {
    data(){
      return{
        showBorrowDataMore:true,
        showLoanDataMore:true,
        showAssignmentDebtDataMore:true,
        bTotal:0,
        bPageNum:1,
        bPageSize:10,
        orderBy:'publish_time',
        realTimeStatus:'',
        borrowProjects:[],
        borrowMainArray:[],
        lTotal:0,
        lPageNum:1,
        lPageSize:10,
        loanProjects:[],
        aTotal:0,
        aPageNum:1,
        aPageSize:10,
        assignmentDebt:[],
        dialogMsgVisible:false,
        state:'',
        goType:'',
        projectCategoryArray:[],
        repaymentMethodArray:[],
        filters:{
          projectCategory:'all',
          repaymentMethod:'all'
        },
      }
    },
    methods:{
      handleTabClick(tab, event) {
        if(tab.name === 'borrow'){
          this.activateBtn('borrow_publish_time');
        }
        if(tab.name === 'loan'){
          this.activateBtn('loan_publish_time');
        }
        if(tab.name === 'assignment'){
          this.activateBtn('assignment_publish_time');
        }
      },
      handleCurrentChangeBorrow(val) {
        this.bPageNum = val;
        this.getBorrowProjects();
        this.getBackTop();
      },


      getBorrowProjects(statusMore){
        let that=this;
        reqGetOneByCode({code:'project_on_the_shelf'}).then((res) =>{
          if(res.data.code == 1){
            if(statusMore === 'borrowMore'){
              that.bPageNum++;
            }else {
              that.bPageNum = 1;
            }
            let para = {
              pageNum: that.bPageNum,
              pageSize: that.bPageSize,
              projectStatus: res.data.data.id,
              orderBy: that.orderBy,
              projectCategory:that.filters.projectCategory,
              repaymentMethod:that.filters.repaymentMethod
            };
            reqBorrowProjectListPage(para).then((res) =>{
              if(res.data.code === 1){
                that.bTotal = res.data.data.total;
                if(statusMore === 'borrowMore'){
                  that.borrowProjects = that.borrowProjects.concat(res.data.data.list);
                }else{
                  that.borrowProjects = res.data.data.list;
                }
                if(that.bTotal === that.borrowProjects.length){
                  that.showBorrowDataMore = false;
                }else {
                  that.showBorrowDataMore = true;
                }
              }else {
                  that.bTotal = 0;
                  that.borrowProjects = [];
                  that.showBorrowDataMore = false;
              }
            });
          }
        });
      },
      borrowMainFormatter: function(value){
        var res = '';
        this.borrowMainArray.forEach(function (obj, i) {
          if (value == obj.id) {
            res = obj.name;
          }
        });
        return res;
      },
      repaymentMethodFormatter: function(value){
        var res = '';
        this.repaymentMethodArray.forEach(function (obj, i) {
          if (value == obj.id) {
            res = obj.name;
          }
        });
        return res;
      },
      handleCurrentChangeLoan(val) {
        this.lPageNum = val;
        this.getLoanProjects();
        this.getBackTop();
      },
      getLoanProjects(statusMore){
        let that=this;
        reqGetOneByCode({code:'project_on_the_shelf'}).then((res) =>{
          if(res.data.code == 1){
            if(statusMore === 'loanMore'){
              that.lPageNum++;
            }else {
              that.lPageNum = 1;
            }
            let para = {
              pageNum: that.lPageNum,
              pageSize: that.lPageSize,
              projectStatus: res.data.data.id,
              orderBy: that.orderBy,
            };
            reqLoanProjectListPage(para).then((res) =>{
              if(res.data.code === 1){
                that.lTotal = res.data.data.total;
                if(statusMore === 'loanMore'){
                  that.loanProjects = that.loanProjects.concat(res.data.data.list);
                }else{
                  that.loanProjects = res.data.data.list;
                }
                if(that.lTotal === that.loanProjects.length){
                  that.showLoanDataMore = false;
                }else {
                  that.showLoanDataMore = true;
                }
              }else {
                that.showLoanDataMore = false;
                that.lTotal = 0;
                that.loanProjects = [];
              }
            });
          }
        });
      },
      handleCurrentChangeAssignment(val) {
        this.aPageNum = val;
        this.getAssignmentDebts();
        this.getBackTop();
      },
      getAssignmentDebts(statusMore){
        let that=this;
        reqGetOneByCode({code:'project_on_the_shelf'}).then((res) =>{
          if(res.data.code == 1){
            if(statusMore === 'assignmentMore'){
              that.aPageNum++;
            }else {
              that.aPageNum = 1;
            }
            let para = {
              pageNum: that.aPageNum,
              pageSize: that.aPageSize,
              projectStatus: res.data.data.id,
              orderBy: that.orderBy,
              realTimeStatus: that.realTimeStatus,
            };
            reqAssignmentDebtListPage(para).then((res) =>{
              if(res.data.code === 1){
                that.aTotal = res.data.data.total;
                if(statusMore === 'assignmentMore'){
                  that.assignmentDebt = that.assignmentDebt.concat(res.data.data.list);
                }else{
                  that.assignmentDebt = res.data.data.list;
                }
                if(that.aTotal === that.assignmentDebt.length){
                  that.showAssignmentDebtDataMore = false;
                }else {
                  that.showAssignmentDebtDataMore = true;
                }
              }else {
                that.showAssignmentDebtDataMore = false;
                that.aTotal = 0;
                that.assignmentDebt = [];
              }
            });
          }
        });
      },
      // 点击下一页时，页面回滚到顶部
      getBackTop:function () {
        window.scrollTo(0,0);
      },
      getDictionarys: function() {
        var that = this;
        reqGetDictionaryListByCode({code: 'borrow_body'}).then((res) => {
          that.borrowMainArray = res.data.data;
        });

        reqGetDictionaryListByCode({code: 'borrow_type'}).then((res) => {
          that.projectCategoryArray = res.data.data;
        });

        reqGetDictionaryListByCode({code: 'reimbursement_means'}).then((res) => {
          that.repaymentMethodArray = res.data.data;
        });
      },
      activateBtn(btnId){
        var btnIds = ['borrow_publish_time','borrow_amount','borrow_real_time_status','loan_publish_time','loan_amount','loan_real_time_status','assignment_publish_time','assignment_amount','assignment_real_time_status'];
        jQuery.each(btnIds, function(i, val) {
          if(btnId === val){
            $('#'+val).attr('class','el-button el-button--primary el-button--small');
          }else{
            $('#'+val).attr('class','el-button el-button--default el-button--small');
          }
        });
      },
      reOrderProject(pType, orderBy){
        if(orderBy=='publish_time'||orderBy=='amount' || orderBy=='real_time_status'){
          this.orderBy = orderBy;
        }
        this.activateBtn(pType+'_'+orderBy);
        if(pType === 'borrow'){
          this.getBorrowProjects();
        }else if(pType === 'loan'){
          this.getLoanProjects();
        }else{
          this.getAssignmentDebts();
        }
      },
      goProjectDetail(pType, id) {
        reqValidateWebUser({}).then((res) =>{
          if(res.data.code == 1){
            if(pType === 'borrow'){
              this.$router.push({name: 'wxBorrowProjectDetail', query: {id: id,wxBorrowProjectSharing:1}});
            }else if(pType === 'loan'){
              this.$router.push({name: 'wxLoanProjectDetail', query: {id: id,wxLoanProjectSharing:2}});
            }else{
              this.$router.push({name: 'wxAssignmentDebtDetail', query: {id: id,wxAssignmentDebtSharing:3}});
            }
          }else{
            this.state=id;
            this.goType=pType;
            this.dialogMsgVisible = true;
          }
        });
      },
      goRegister(state,goType){
        window.open("https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx3557168303054c37&redirect_uri=http%3a%2f%2fwww.phjd365.com%2fmp&response_type=code&scope=snsapi_userinfo&state="+state+"PLR"+goType+"WX"+"wxProjectList"+"#wechat_redirect");
      },
      goLogin(state,goType){
        this.dialogProjectVisible=false;
        window.open("https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx3557168303054c37&redirect_uri=http%3a%2f%2fwww.phjd365.com%2fmp&response_type=code&scope=snsapi_userinfo&state="+state+"PLL"+goType+"WX"+"wxProjectList"+"#wechat_redirect");
      },
//      getDictionarys: function() {
//        var that = this;
//        reqGetDictionaryListByCode({code: 'borrow_body'}).then((res) => {
//          that.borrowMainArray = res.data.data;
//        });
//        reqGetDictionaryListByCode({code: 'borrow_type'}).then((res) => {
//          that.projectCategoryArray = res.data.data;
//        });
//        reqGetDictionaryListByCode({code: 'reimbursement_means'}).then((res) => {
//          that.repaymentMethodArray = res.data.data;
//        });
//      },

      backWeiXin:function() {
        pushHistory();
        function bodyScroll() {
          var state = {
            title: "title",
            url: ""
          };
          window.history.pushState(state, state.title, state.url);
//              window.location.href ='/wxMyHomePage';
        }

        window.addEventListener("popstate", bodyScroll, false)
        function pushHistory() {
          var state = {
            title: "title",
            url: ""
          };
          window.history.pushState(state, state.title, state.url);
        }
      },
    },
    mounted(){
      this.$store.dispatch('hideHF');
      this.backWeiXin();
      this.getDictionarys();
      this.getBorrowProjects('publish_time', 'desc');
      this.getLoanProjects('publish_time', 'desc');
      this.getAssignmentDebts('publish_time', 'desc');
      this.activateBtn('borrow_publish_time');
    }
  }
</script>
<style slot-scope="scope">
    @import '../../assets/css/wxstyle.css';
</style>



// WEBPACK FOOTER //
// src/components/weChat/WxProjectList.vue